import RecentSearchItem from "./recent-search-item"
import { LinkBtn } from "../buttons"
import { SearchResult } from "../../../types"
import { MutableRefObject } from "react"

interface Props {
  recentSearches: SearchResult[]
  onClickItem: (result: SearchResult) => void
  onClickResetRecentSearches: () => void
  itemRefs: MutableRefObject<(HTMLDivElement | null)[]>
  activeIndex: number
  onItemKeyDown: (e: React.KeyboardEvent, index: number) => void
}

const RecentSearches = ({
  recentSearches,
  onClickItem,
  onClickResetRecentSearches,
  itemRefs,
  activeIndex,
  onItemKeyDown
}: Props) => {
  const handleClearKeyDown = (
    e: React.KeyboardEvent<HTMLButtonElement | HTMLAnchorElement>
  ) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault()
      onClickResetRecentSearches()
    } else {
      // Pass other keys (like arrows) to the parent handler
      onItemKeyDown(e as any, 0)
    }
  }

  return (
    <div className="p-4">
      <div className="text-sm text-neutral-400 font-semibold flex items-center">
        <span>Recent searches</span>
        {recentSearches.length > 0 && (
          <LinkBtn
            refProp={el => (itemRefs.current[0] = el as any)}
            type="button"
            className="mx-2 !p-0 text-xs focus:ring-offset-2"
            onClick={onClickResetRecentSearches}
            onKeyDown={handleClearKeyDown}
          >
            Clear
          </LinkBtn>
        )}
      </div>
      <div className="py-2">
        {recentSearches.length ? (
          recentSearches.map((result, idx) => (
            <RecentSearchItem
              key={result.id}
              ref={el => (itemRefs.current[idx + 1] = el)}
              data={result}
              isActive={activeIndex === idx + 1}
              onClickItem={onClickItem}
              onKeyDown={e => onItemKeyDown(e, idx + 1)}
            />
          ))
        ) : (
          <div className="py-2 text-sm text-neutral-400 font-medium">
            No recent searches found.
          </div>
        )}
      </div>
    </div>
  )
}

export default RecentSearches
